import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';
import { useBrokerDetailsQuery } from '../../../../queries/brokerDetailsQueries';
import { applicationInsights } from '../../../../../../ApplicationInsights';
import { BfiDataGrid, Column, formatDateTime } from '@apply/ui';
import { GridSettingType, BrokerStatusTypeOptions } from '@apply/constants';

export const StatusHistoryTable = () => {
    const brokerId = useBrokerDetailsStore((s) => s.brokerId);
    const isAdmin = useBrokerDetailsStore((s) => s.isAdmin);
    const { data: broker } = useBrokerDetailsQuery(brokerId, isAdmin);

    const onDateTimeRender = (e: unknown) => {
        if (!e || typeof e !== 'object' || !('value' in e) || !(e.value instanceof Date)) {
            return null;
        }
        return formatDateTime(e.value);
    };

    const onStatusRender = (e: unknown) => {
        if (!e || typeof e !== 'object' || !('value' in e)) {
            return 'Unknown';
        }
        const option = BrokerStatusTypeOptions.find((a) => a.id === e.value);
        if (!option) {
            return 'Unknown';
        }
        return option.name;
    };

    const statusHistory = broker && 'statusHistory' in broker ? broker.statusHistory : [];

    return (
        <BfiDataGrid
            dataSource={statusHistory}
            keyExpr='id'
            showBorders={true}
            showRowLines={false}
            rowAlternationEnabled={true}
            remoteOperations={false}
            allowColumnReordering={true}
            allowColumnResizing={true}
            noDataText='No Status History available'
            defaultPageSize={12}
            allowedPageSizes={[12]}
            applicationInsights={applicationInsights}
            gridType={GridSettingType.BrokerStatusHistory}
        >
            <Column
                dataField='statusId'
                caption='Status'
                width={200}
                cellRender={onStatusRender}
                alignment={'left'}
            />
            <Column
                dataField='createdAt'
                caption='On'
                width={150}
                cellRender={onDateTimeRender}
                alignment={'left'}
            />
            <Column
                dataField='createdBy'
                caption='By'
                width={300}
                alignment={'left'}
            />
        </BfiDataGrid>
    );
};
